<template>
  <section class="border-top">
    <div class="left">
      <h2 v-translate>Nastavení jazyků</h2>
    </div>
  <div class="right">
    <div class="field_left">
      <checkbox-input
          id="languages_enabled"
          v-model="entity.allow_language_selection"
          ref="languages_enabled"
          :disabled="!isEditable"
      >
        <translate class="translate">Povolit vlastní nastavení jazyků</translate>
      </checkbox-input>
    </div>
    </div>
    <div class="right">
    <SortableCheckboxList
        :items="languageOptions"
        v-model="entity.languages"
        :disabled="!isEditable"
        :show-id="false"
        name="languagelist"
        :allow-search="false"
    />
  </div>
  </section>
</template>

<script>
import SortableCheckboxList from "../../../common/SortableCheckboxList.vue";

export default {
  name: "Languages",
  components: {SortableCheckboxList},
  props: {
    entity: Object,
    isEditable: Boolean,
    languageOptions: Array,
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/initialProcessSetup/forms/Languages.vue